import { render, staticRenderFns } from "./AssignStoreBadgeToTemplate.vue?vue&type=template&id=3f659b34&scoped=true&"
import script from "./AssignStoreBadgeToTemplate.vue?vue&type=script&lang=js&"
export * from "./AssignStoreBadgeToTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AssignStoreBadgeToTemplate.vue?vue&type=style&index=0&id=3f659b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f659b34",
  null
  
)

export default component.exports